import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-mail-confirmation',
    templateUrl: './mail-confirmation.component.html',
    styleUrls: ['./mail-confirmation.component.scss']
})
export class MailConfirmationComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<MailConfirmationComponent>,
    ) { }

    ngOnInit(): void {
    }

    close() {
        this.dialogRef.close();
    }

}
